var exports = {
  "Vx": "xfd349460--447513--specifications",
  "yT": "xfd349460--447513--specification",
  "Qq": "xfd349460--447513--text",
  "Uq": "xfd349460--447513--value",
};

module.exports = exports;
